document.addEventListener('DOMContentLoaded', function() {
  var maxWaitTime = 2000; 
  var checkInterval = 100; 
  var elapsedTime = 0;
  
  function checkUtmPromotionsAndValidate() {
    if (window.utmPromotions !== undefined) {
      validateUtmCookie();
    } else {
      elapsedTime += checkInterval;
      if (elapsedTime < maxWaitTime) {
        setTimeout(checkUtmPromotionsAndValidate, checkInterval);
      }
    }
  }
  
  setTimeout(checkUtmPromotionsAndValidate, 100);
  
  function validateUtmCookie() {
    try {
      var cached = (document.cookie.match(/(^|;)\s*utm_campaign_cached=([^;]*)/) || [])[2];
      
      if (!cached) {
        checkCartAttribute();
        return;
      }
      
      try { 
        cached = decodeURIComponent(cached); 
      } catch(e) { 
        return;
      }
      
      if (!window.utmPromotions || !window.utmPromotions[cached]) {
        //removeCookie();
        updateCartAttribute(null);
        return;
      }
      
      var promo = window.utmPromotions[cached];
      var now = new Date();
      
      if (promo.end) {
        var endDate = new Date(promo.end);
        
        if (!isNaN(endDate.getTime()) && now > endDate) {
          //removeCookie();
          updateCartAttribute(null);
          return;
        }
      }
      
      if (promo.start) {
        var startDate = new Date(promo.start);
        
        if (!isNaN(startDate.getTime()) && now < startDate) {
          //removeCookie();
          updateCartAttribute(null);
          return;
        }
      }
      
    } catch (e) {}
  }
  
  function checkCartAttribute() {
    fetch('/cart.js', { 
      method: 'GET', 
      credentials: 'same-origin',
      headers: {
        'Cache-Control': 'no-cache',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      if (cart.attributes && cart.attributes.utm_campaign) {
        var utmInCart = cart.attributes.utm_campaign;
        if (!window.utmPromotions || !window.utmPromotions[utmInCart]) {
          updateCartAttribute(null);
        }
      }
    })
    .catch(function(){});
  }
  
  function removeCookie() {
    var expiresDate = new Date(0).toUTCString();
    
    document.cookie = 'utm_campaign_cached=; path=/; expires=' + expiresDate + '; SameSite=Lax';
    document.cookie = 'utm_campaign_cached=; path=/; expires=' + expiresDate + '; domain=' + window.location.hostname + '; SameSite=Lax';
    document.cookie = 'utm_campaign_cached=; expires=' + expiresDate + '; SameSite=Lax';
    document.cookie = 'utm_campaign_cached=; path=/; expires=' + expiresDate;
  }
  
  function updateCartAttribute(value) {
    var form = new FormData();
    form.append('attributes[utm_campaign]', value || '');
    
    fetch('/cart/update.js', { 
      method: 'POST', 
      body: form, 
      credentials: 'same-origin',
      headers: {
        'Cache-Control': 'no-cache',
        'Accept': 'application/json'
      }
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function(data) {
      if (value === null) {
        var reloadUrl = window.location.href;
        var separator = reloadUrl.indexOf('?') !== -1 ? '&' : '?';
        reloadUrl = reloadUrl + separator + '_nocache=' + new Date().getTime();
        
        //window.location.href = reloadUrl;
      }
    })
    .catch(function(){});
  }
});